import React, {useState, useEffect, useRef} from "react";
import axios from 'axios';
import { Navigate, useParams } from "react-router-dom";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi"; 

const RewardwalletEdit = ()=>{
     const [walletamount, setWalletamount ] = useState('');
     const [maxpayout, setMaxpayout ] = useState('');
     const [validfrom, setValidfrom ] = useState('');
     const [validuntil, setValiduntil ] = useState('');
    const [redirect, setRedirect] = useState(false);
    const ref = useRef<HTMLInputElement>(null);

    let {id} = useParams();
    useEffect(() =>{
        (
            async () => {
                 const {data} = await axios.get(`rewardwallet/${id}`);
                 setWalletamount(data.walletamount);
                 setMaxpayout(data.maxpayout);
                 setValidfrom(data.validfrom);
                 setValiduntil(data.validuntil);
             }
             )();
        },[id]);
        const submit = async (e)=>{
            e.preventDefault();
            const {data} = await axios.put(`rewardwallet/${id}`, {
            walletamount,
            maxpayout,
            validfrom,
            validuntil,
        });
        console.log(data);
        setRedirect(true);
    };
     
    if(redirect){
         return <Navigate to={'/rewardwallet'} />
    }
    return (
        <Wrapper pageTitle={'Edit Rewardwallet'}>
            <InnerNav createLink={'/rewardwalletCreate'} listLink={'/rewardwallet'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Walletamount </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Walletamount" value={walletamount}
                        onChange = {e => setWalletamount(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Maxpayout </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Maxpayout" value={maxpayout}
                        onChange = {e => setMaxpayout(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Validfrom </span>
                        <input type="datetime-local"
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Validfrom" value={validfrom}
                        onChange = {e => setValidfrom(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Validuntil </span>
                        <input type="datetime-local"
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Validuntil" value={validuntil}
                        onChange = {e => setValiduntil(e.target.value)} />
                    </label>

                     <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                         <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                         onClick={submit}
                         > <FiSave /> <span className="ml-3">Save</span> </button>
                         </label>
                     </div>
                 </div>
             </form>
         </Wrapper>
     );
};
export default RewardwalletEdit;